import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchCompany({ payload }) {
  try {
    const res = yield call(API.fetchCompanyDetails, payload);
    const { data } = res;
    yield put(actions.fetchCompanyDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchCatalog({ payload }) {
  try {
    const res = yield call(API.fetchCompanyCatalog, payload);
    const { data } = res;
    yield put(actions.fetchCatalogSuccess(data));
  } catch (err) {
    yield put(actions.fetchCatalogFailure(err?.response?.data));
  }
}

export function* handleFetchCommodityCategories({ payload }) {
  try {
    const res = yield call(API.fetchAllCommodityCategories, payload);
    const { data } = res;
    yield put(actions.fetchCommodityCategoriesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommodityCategoriesFailure(err?.response?.data));
  }
}

export function* handleFetchCommodity({ payload }) {
  try {
    const res = yield call(API.fetchAllTestCommodities, payload);
    const { data } = res;
    yield put(actions.fetchCommoditySuccess(data));
  } catch (err) {
    yield put(actions.fetchCommodityFailure(err?.response?.data));
  }
}

export function* handleFetchTestCategory({ payload }) {
  try {
    const res = yield call(API.fetchAllTestCategories, payload);
    const { data } = res;
    yield put(actions.fetchTestCategorySuccess(data));
  } catch (err) {
    yield put(actions.fetchTestCategoryFailure(err?.response?.data));
  }
}

export function* handleUpdateTestPriceInCompanyCatalog({ payload }) {
  try {
    const res = yield call(API.updatePriceOfTestInCompanyCatalog, payload);
    const { data } = res;
    yield put(actions.updateTestPriceInCompanyCatalogSuccess(data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(
      actions.updateTestPriceInCompanyCatalogFailure(err?.response?.data)
    );
    payload.onFailure();
  }
}

export function* handleDeleteTestInCompanyCatalog({ payload }) {
  try {
    const res = yield call(API.removeTestInCompanyCatalog, payload);
    const { data } = res;
    yield put(actions.removeTestFromCompanyCatalogSuccess(data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.removeTestFromCompanyCatalogFailure(err?.response?.data));
    payload.onFailure();
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* companyCatalogSaga() {
  yield takeLatest(actions.fetchCompanyDetails.type, handleFetchCompany);
  yield takeLatest(actions.fetchCatalog.type, handleFetchCatalog);
  yield takeLatest(
    actions.fetchCommodityCategories.type,
    handleFetchCommodityCategories
  );
  yield takeLatest(actions.fetchCommodity.type, handleFetchCommodity);
  yield takeLatest(actions.fetchTestCategory.type, handleFetchTestCategory);
  yield takeEvery(
    actions.updateTestPriceInCompanyCatalog.type,
    handleUpdateTestPriceInCompanyCatalog
  );
  yield takeEvery(
    actions.removeTestFromCompanyCatalog.type,
    handleDeleteTestInCompanyCatalog
  );
}
